var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path2, _path3, _rect7, _path4, _path5, _rect8, _rect9, _rect10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 92,
    viewBox: "0 0 153 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.3188 23H93.0971L107.95 52.8148H45.0498L60.3188 23Z",
    fill: "#2A333D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.65,
    y: 16.1851,
    width: 35.7,
    height: 40.8889,
    rx: 4,
    fill: "#778697"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62.9,
    y: 21.2961,
    width: 27.2,
    height: 2.55556,
    rx: 1.27778,
    fill: "#96A8BB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.9,
    y: 26.4072,
    width: 13.6,
    height: 2.55556,
    rx: 1.27778,
    fill: "#96A8BB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62.9,
    y: 34.074,
    width: 17.85,
    height: 2.55556,
    rx: 1.27778,
    fill: "#96A8BB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 54.4,
    y: 40.8887,
    width: 44.2,
    height: 26.4074,
    rx: 4,
    fill: "#6A7787"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50.9998,
    y: 46,
    width: 51,
    height: 26.4074,
    rx: 4,
    fill: "#5A6776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0498 54.259C45.0498 52.0499 46.8407 50.259 49.0498 50.259H60.8329C63.042 50.259 64.8329 52.0499 64.8329 54.259V55.4276C64.8329 55.9799 65.2806 56.4276 65.8329 56.4276H87.674C88.2263 56.4276 88.674 55.9799 88.674 55.4276V54.259C88.674 52.0499 90.4649 50.259 92.674 50.259H103.95C106.159 50.259 107.95 52.0499 107.95 54.259V76.0738C107.95 78.283 106.159 80.0738 103.95 80.0738H49.0498C46.8407 80.0738 45.0498 78.283 45.0498 76.0738V54.259Z",
    fill: "#2A333D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6997 68.1479V69.5554C69.6997 70.6599 70.5951 71.5554 71.6997 71.5554H81.2997C82.4043 71.5554 83.2997 70.6599 83.2997 69.5554V68.1479",
    stroke: "#5A6776",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3.40371,
    height: 9.36019,
    transform: "matrix(0.706337 -0.707876 0.706337 0.707876 109.91 53.7803)",
    fill: "#99AABE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.396 58.7198L117.243 54.8647L127.852 64.7163C129.213 65.9808 129.254 68.126 127.941 69.4416C126.629 70.7572 124.488 70.7163 123.226 69.3516L113.396 58.7198Z",
    fill: "#6A7787"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.713 53.1781C118.352 46.5247 118.352 35.7375 111.713 29.0841C105.074 22.4307 94.3099 22.4307 87.671 29.0841C81.032 35.7375 81.032 46.5247 87.671 53.1781C94.3099 59.8315 105.074 59.8315 111.713 53.1781ZM109.182 50.6418C114.424 45.3891 114.424 36.8729 109.182 31.6202C103.941 26.3675 95.4435 26.3675 90.2022 31.6202C84.961 36.8729 84.961 45.3891 90.2022 50.6418C95.4435 55.8944 103.941 55.8944 109.182 50.6418Z",
    fill: "#CAD9E9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 5.17494,
    height: 5.17494,
    transform: "matrix(0.706337 -0.707876 0.706337 0.707876 26.3499 44.5522)",
    fill: "#38424D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 4.39339,
    height: 4.39339,
    transform: "matrix(0.706337 -0.707876 0.706337 0.707876 136 66.999)",
    fill: "#38424D"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.73048,
    height: 3.73048,
    transform: "matrix(0.706337 -0.707876 0.706337 0.707876 100.767 10.8608)",
    fill: "#38424D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.6f375e1d3ba35ed8dc865920f9c97e18.svg";
export { ForwardRef as ReactComponent };